import React from 'react';
import { CardSkeleton } from 'src/modules/shared/components/atoms/cards/card-skeleton';
import { TextSkeleton } from 'src/modules/shared/components/atoms/text/text-skeleton';
import { ViewMode } from '../view-toggle';

interface AgendaSkeletonProps {
  view: ViewMode;
}

export const AgendaSkeleton: React.FC<AgendaSkeletonProps> = ({ view }) => {
  if (view === 'calendar') {
    return (
      <div className="h-full">
        {/* Calendar skeleton */}
        <div className="grid grid-cols-7 gap-1 mb-4">
          {/* Header row with days */}
          {Array.from({ length: 7 }).map((_, index) => (
            <div
              key={index}
              className="h-8 bg-gray-200 rounded animate-pulse"
            />
          ))}
        </div>

        {/* Calendar grid skeleton */}
        <div className="grid grid-cols-7 gap-1 h-[calc(100vh-16rem)]">
          {Array.from({ length: 35 }).map((_, index) => (
            <div
              key={index}
              className="flex flex-col border border-gray-100 bg-gray-50 rounded p-2 space-y-1"
            >
              <TextSkeleton className="h-4 w-[1.5rem] self-end" />
              {/* Fixed task blocks */}
              {index % 3 === 0 && (
                <TextSkeleton variant="primary" className="h-2" />
              )}
              {index % 4 === 0 && (
                <TextSkeleton variant="secondary" className="h-2" />
              )}
            </div>
          ))}
        </div>
      </div>
    );
  }

  // List view skeleton
  return (
    <div className="space-y-6">
      <div>
        <div className="h-5 w-24 bg-gray-200 rounded animate-pulse mb-3" />
        <div className="space-y-3">
          <CardSkeleton
            header={{
              avatar: true,
              title: true,
              action: true,
            }}
          />
          <CardSkeleton
            header={{
              avatar: true,
              title: true,
              action: true,
            }}
          />
          <CardSkeleton
            header={{
              avatar: true,
              title: true,
              action: true,
            }}
          />
        </div>
      </div>
      <div>
        <div className="h-5 w-20 bg-gray-200 rounded animate-pulse mb-3" />
        <div className="space-y-3">
          <CardSkeleton
            header={{
              avatar: true,
              title: true,
              action: true,
            }}
          />
          <CardSkeleton
            header={{
              avatar: true,
              title: true,
              action: true,
            }}
          />
        </div>
      </div>
    </div>
  );
};
